module.exports = __webpack_public_path__ + "/static/assets/logo.4c5d90cf.svg";